/**
 * ReportsSignupCta — inline conversion banner for the public Reports pages
 * (3/9 SEO expansion: the library is fully public, conversion relies on CTAs).
 */
import React from "react";
import { Link } from "react-router-dom";
import { Bell, Search, MessageSquare } from "lucide-react";
import { useAuth } from "../../AuthContext";

export default function ReportsSignupCta({ dm, variant = "list", testid = "reports-signup-cta", total = 0 }) {
  const countLabel = total >= 50 ? `${Math.floor(total / 50) * 50}+` : "all our";
  const { user } = useAuth();
  if (user) return null;
  const isBrief = variant === "brief";
  return (
    <aside
      data-testid={testid}
      className="rounded-2xl p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-5"
      style={{ background: dm ? "#10171a" : "#0f2529", border: "1px solid rgba(143,212,220,0.18)" }}
    >
      <div className="flex-1">
        <p className="text-xs font-bold uppercase tracking-wider mb-1" style={{ color: "#8fd4dc" }}>
          {isBrief ? "Every week, the new reports" : "Free account"}
        </p>
        <h3 className="font-serif text-lg md:text-xl font-bold text-white leading-snug">
          {isBrief
            ? "Get the new industry reports in your inbox — briefed, every week."
            : "Search the whole library, save reports and ask the data."}
        </h3>
        <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-1.5 text-xs" style={{ color: "#a9c2c6" }}>
          <li className="flex items-center gap-1.5"><Search className="w-3.5 h-3.5" /> Full-text search across {countLabel} reports</li>
          <li className="flex items-center gap-1.5"><Bell className="w-3.5 h-3.5" /> Weekly report alerts</li>
          <li className="flex items-center gap-1.5"><MessageSquare className="w-3.5 h-3.5" /> Ask the Data on official statistics</li>
        </ul>
      </div>
      <Link
        to="/auth"
        data-testid={`${testid}-button`}
        className="flex-shrink-0 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors"
        style={{ background: "#8fd4dc", color: "#001f24" }}
      >
        Create a free account →
      </Link>
    </aside>
  );
}
